



































import {Component, Vue} from 'vue-property-decorator';
import {getModule} from 'vuex-module-decorators';
import {BaseStore} from './store/BaseStore';
import {OpenGaoDeiDiTuUtils} from "@/utils/OpenGaoDeiDiTuUtils";
import {XmppUtils} from "@/xmpp/XmppUtils";
import {JiGuang} from "@/jiguang/JiGuang";
import router from "@/router";
import {Strophe} from "@/xmpp/Strophe";


@Component({
  components: {},
})
export default class LayoutDefault extends Vue {
  tab = 'home';
  // a(){
  //   JPush.in
  // }

  connection!: Strophe.Connection;
  private loginSuccessful() {
    const item: string | null = localStorage.getItem('entryPoint');
    const xmppUtils = new XmppUtils();
    xmppUtils.xmppLogin();
    this.connection = XmppUtils.connection;
    // const jiGuang = new JiGuang();
    JiGuang.mount();
    if (item === null) {
      // router.go(-1);
      const location = "KeShangSelect" as any
      if (location.name !== this.$route.name) {
        router.replace(location);
      }
    } else {
      // console.log('+++++++')
      // setTimeout(()=>{
      //   window.location.reload();
      // },600000);
      const location = JSON.parse(item);
      if (location.name !== this.$route.name) {
        router.replace(location);
      }
    }

    // this.$router.push("/keShangSelect")
  }

  checkToken(){
    const token = window.localStorage.getItem("AuthToken")as any
    const token1 = JSON.parse(token);
    if (token1!==null||token1!=''){
      this.loginSuccessful()
    }
  }


  private mounted() {
    window.addEventListener('message', (e) => {
      // console.log(e)
      try {
        const eygMessage = e.data
        const diaoyongType = eygMessage.split(",")[0]
        // console.log(eygMessage.split(",")[0])
        // console.log(eygMessage.split(",")[1])
        // console.log(eygMessage.split(",")[2])
        if (diaoyongType === '调用消息') {
          const diaoyongPhone = eygMessage.split(",")[1] + '@rtc1'
          const diaoyongPeople = eygMessage.split(",")[2]
          // this.$router.push({name:'chatPage',params:{jid:diaoyongPhone+"@rtc1",name:diaoyongPeople+""}})
          // this.$router.push({name:'chatPage',params:{jid:diaoyongPhone+"@rtc1",name:diaoyongPeople}})
          getModule(BaseStore).setYgMessage('chatPage')
          getModule(BaseStore).setPhone(diaoyongPhone)
          getModule(BaseStore).setPersonName(diaoyongPeople)
        }
        if (diaoyongType === '调用高德地图') {
          const jinDU = eygMessage.split(",")[1]
          const weiDu = eygMessage.split(",")[2]
          const endAddress = eygMessage.split(",")[3]
          OpenGaoDeiDiTuUtils.openGaoDei(weiDu, jinDU, endAddress)
        }
      } catch (e) {
        const a = 1
      }


    }, false)
    // this.diaoyong()
    // window.addEventListener("调用消息",evt => this.$router.push({name:'chatPage'}))

    this.checkToken()

  }
}
